'use client';

import ReactDOM from 'react-dom';

export default function HeadlineImagePreload({ imageUrl }: { imageUrl: string }) {
    if (imageUrl) {
        ReactDOM.preload(imageUrl, { as: 'image' });
    }
    return null;
} 